'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TaskMutationTrackingService = function () {
    function TaskMutationTrackingService($state) {
        _classCallCheck(this, TaskMutationTrackingService);

        this.$state = $state;
        this.statesWhichCanTriggerTaskMutation = ['campaignDetail', 'campaignContactDetail', 'contactsDetail', 'customerContactsDetail', 'investorsDetail', 'customerInvestorsDetail', 'tasks'];
    }

    _createClass(TaskMutationTrackingService, [{
        key: 'canTriggerTaskMutation',
        value: function canTriggerTaskMutation(fromState, toState) {
            // this.displayStatesInConsole(fromState, toState);
            return this.statesWhichCanTriggerTaskMutation.indexOf(toState.name) > -1;
        }
    }, {
        key: 'storeMutationTriggeringStateInSessionStore',
        value: function storeMutationTriggeringStateInSessionStore(state, parameters) {
            sessionStorage.setItem('task-mutation-triggering-state', JSON.stringify(state));
            sessionStorage.setItem('task-mutation-triggering-state-params', JSON.stringify(parameters));
        }
    }, {
        key: 'redirectToStateInSessionStore',
        value: function redirectToStateInSessionStore() {
            var state = JSON.parse(sessionStorage.getItem('task-mutation-triggering-state'));
            var params = JSON.parse(sessionStorage.getItem('task-mutation-triggering-state-params'));
            this.$state.go(state.name, params, { reload: true });
        }
    }, {
        key: 'clearTaskMutationTrackingInSessionStore',
        value: function clearTaskMutationTrackingInSessionStore() {
            sessionStorage.removeItem('task-mutation-triggering-state');
            sessionStorage.removeItem('task-mutation-triggering-state-params');
        }
    }, {
        key: 'displayStatesInConsole',
        value: function displayStatesInConsole(fromState, toState) {
            console.clear();
            console.log('> from state:\n', fromState);
            console.log('> to state:\n', toState);
        }
    }]);

    return TaskMutationTrackingService;
}();

exports.default = TaskMutationTrackingService;


/** WEBPACK FOOTER **
 ** ./src/app/services/taskMutationTrackingService.js
 **/